<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Task answer')"></breadcrumbs>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <form-create-task-answer
            :task="task">
          </form-create-task-answer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import Breadcrumbs from "../../Layout/Breadcrumbs";
  import FormCreateTaskAnswer from "../../Forms/Learn/FormCreateAnswerTask";

  export default {
    metaInfo() {
      return {
        title: this.$i18n.t('Task answer')
      }
    },
    components: {FormCreateTaskAnswer, Breadcrumbs},
    async mounted() {
      await this.fetchData();
    },
    watch: {
      '$route': 'fetchData'
    },
    computed: {
      task() {
        return this.$store.getters['student/task/getCurrentTask']
      }
    },
    methods: {
      async fetchData() {
        await this.$store.dispatch(
          'student/task/loadTask',
          {
            urlParams: {...this.$route.params}
          }
        )
      }
    }
  };
</script>
<style></style>
